<template>
  <div>
    <div class="Header" :class="handerbg ? 'h-bgTwo' : 'h-bg'">
      <div class="nav">
        <!-- 左边 -->
        <div class="le-nav">
          <div class="logo">
            <router-link to="/">
              <img src="@/assets/header/logo.png" alt="logo" />
            </router-link>
          </div>

          <div class="subnav">
            <div v-for="(item, index) in gametitlelist" :key="index" class="nav_list">
              <router-link :to="{ name: item.routelink }">
                <span class="nav_span">{{ item.title }}</span>
              </router-link>
              <div class="heiden-box" :style="{ 'display:none': item.title == '热门' }">
                <div class="game_box" v-if="item.gamelist">
                  <div class="li-game" v-for="(game, indesx) in item.gamelist" :key="indesx" >
                    <img v-lazy="game.logo_url" lazy="error" />
                    <div class="li-right">
                      
                      <div class="v-text">{{ gametitle(game.title,0)  }}</div>
                      <div class="v-subtitle">{{ gametitle(game.title,1)  }}</div>
                      <div class="v-btn" @click="SetGame(game)">立即开始</div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右边 -->
        <div class="re-nav">
          <div class="kf_box">
            <router-link to="/Promotion">
              <div class="kf">
                <img src="@/assets/header/youhui.png" />
                <p>优惠</p>
              </div>
            </router-link>
            <div class="kf" @click="Getlink(1)">
              <img src="@/assets/header/kefu.png" />
              <p>客服</p>
            </div>

            <div class="kf_last">
              <img src="@/assets/header/rexian.png" />
              <p>热线</p>
              <div class="kf_content-box">
                <div class="showbox-link">
                  <div class="QQlinkbox" @click="Getlink(2)">代理热线</div>
                </div>
              </div>
            </div>

          </div>

          <el-form v-if="$store.state.islogin == 0" :inline="true" ref="formInline" :rules="rules" :model="formInline"
            class="demo-form" :show-message="false">
            <el-form-item prop="name">
              <el-input v-model="formInline.name" placeholder="用户名" class="inputbox" size="small" maxlength="12"
                minlength="6"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="formInline.password" placeholder="密码" class="inputbox" show-password size="small"
                maxlength="12" minlength="6" @keyup.native.enter="onSubmit('formInline')"></el-input>
              <span class="pawend-text" @click="openwangdailog">忘记？</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('formInline')" size="mini"
                style="background-color: #ecc360;border: none;" class="btn">登入</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" class="btn" @click="openrequset">注册</el-button>
            </el-form-item>
          </el-form>

          <div class="infobox" v-else>
            <div class="actver"></div>
            <router-link to="/Member/Transfer">
              <span class="name">{{ $store.state.userinfo.name }}</span>
            </router-link>
            <!-- <div class="vip"> -->
            <div class="la-conntnet">
              <div class="li-he">
                <img src="@/assets/header/home-infoicon1.png" alt />
                <router-link to="/Member/Transfer">
                  <p>余额</p>
                </router-link>
                <i class="el-icon-refresh" :class="{ refresh_active: isreshleh }" @click="RefreshMoney"></i>
              </div>
              <p class="moeny_text">CN￥ {{ $store.state.userinfo.money == 0 ? '0.00' : $store.state.userinfo.money }}
              </p>

              <router-link to="/Member/Deposit">
                <div class="li-io">
                  <img src="@/assets/header/home-infoicon2.png" />
                  <p>存款</p>
                </div>
              </router-link>
              <router-link to="/Member/Withdraw">
                <div class="li-io">
                  <img src="@/assets/header/home-infoicon3.png" />
                  <p>取款</p>
                </div>
              </router-link>
              <!-- <router-link to="/Member/Vip">
                  <div class="li-io">
                    <img src="@/assets/header/home-infoicon4.png" />
                    <p>VIP特权</p>
                  </div>
                </router-link> -->
              <router-link to="/Member/MemberInfo">
                <div class="li-io">
                  <img src="@/assets/header/home-infoicon5.png" />
                  <p>账号设定</p>
                </div>
              </router-link>
              <div class="li-io" @click="letout">
                <img src="@/assets/header/home-infoicon6.png" />
                <p>退出</p>
              </div>
            </div>
            <!-- </div> -->
            <i class="el-icon-caret-bottom"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 验证码 -->
    <Chptcha></Chptcha>

    <!-- 登录 -->
    <el-dialog :visible.sync="DialogLogin" width="880px" center class="diags">
      <div class="dialog-loginbox">
        <div class="letimg">
          <img src="@/assets/header/config_login.png" />
        </div>

        <div class="rightfrom">
          <el-form class="fromboc" :rules="rules" ref="Loginfrom" :model="Loginfrom">
            <el-form-item>
              <el-input placeholder="用户名" v-model="Loginfrom.name"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="密码" show-password v-model="Loginfrom.password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="btnd" @click="sunmitLogin('Loginfrom')">登录</el-button>
            </el-form-item>
            <el-form-item>
              <div class="ptexts">
                <p @click="openwangdailog">忘记？</p>
                <p>还没有账号？<span @click="openrequset">注册</span></p>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 忘记 -->
    <DialogWang :showwang="DialogWangji" @showWangji="showWangji"></DialogWang>

    <!-- 注册 -->
    <Register :showRegister="DialogRegiter" @isloginChptcha="isLoginCaptcha" @closeRegiter="closeRegiter"
      @upLogin="Openligin"></Register>

  </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
import DialogWang from '@/components/Headers/Forget.vue'
import Register from '@/components/Headers/Register.vue'
import Chptcha from '@/components/Headers/Captcha.vue'
import {
  getLogin,
  getme,
  getgames,
  getgamelist,
  logout,
  getConfig
} from '@/http/api.js'


export default {
  name: 'Headerpage',
  components: {
    DialogWang,
    Register,
    Chptcha
  },
  data() {

    return {
      formInline: {
        name: '',
        password: '',
        key: '',
      },

      Loginfrom: {
        name: '',
        password: '',
        key: '',
      },

      handerbg: false, // 头部背景
      gametitlelist: [], // 游戏标题
      gamechild: [],

      DialogRegiter: false, // 注册弹窗
      DialogLogin: false, // 登录弹窗
      DialogWangji: false, // 忘记弹窗

      isreshleh: false, // 刷新钱包
      servicelink: null, // 客服连接
      QQlink: null,
      isopenChatcha: null, // 是否打开验证码 -> 注册页面获取

      routerlist: [
        {
          id: '热门',
          path: 'Hotgame',
        },
        {
          id: '真人',
          path: 'Live',
        },
        {
          id: '电子',
          path: 'Game',
        },
        {
          id: '棋牌',
          path: 'Board',
        },
        {
          id: '体育',
          path: 'Sport',
        },
        {
          id: '电竞',
          path: 'Esports',
        },
        {
          id: '彩票',
          path: 'Lottery',
        },
        {
          id: '捕鱼',
          path: 'Fish',
        },
      ],

      rules: {
        name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
          {
            min: 6,
            max: 12,
            message: '用户名长度在 6 到 12 个字符',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 12,
            message: '密码长度在 6 到 12 个字符',
            trigger: 'blur',
          },
        ],
      },

    }
  },

  methods: {
    // 首页直接登录 -> 提交
    onSubmit(formdata) {
      this.$refs[formdata].validate((valid, obj) => {
        // 如果 valid 为 true
        if (valid) {
          // 直接调用打开验证码函数
          this.isopenChatcha == '1' ? this.$store.dispatch('ChangeCaptcha', true) : this.setLogin(this.formInline)
        } else {
          let arr = []
          for (let key in obj) {
            arr.push(obj[key][0].message)
          }
          Message.error({
            message: arr[0],
            offset: 80,
          })
          return false
        }
      })
    },



    // 获取是否打开验证码 0 || 1
    isLoginCaptcha(index) {
      this.isopenChatcha = index
    },



    // 弹窗登录
    sunmitLogin() {
      this.isopenChatcha == '1' ? this.$store.dispatch('ChangeCaptcha', true) : this.setLogin(this.Loginfrom)
    },



    // 打开注册弹窗
    openrequset() {
      this.DialogLogin = false
      setTimeout(() => {
        this.DialogRegiter = true
      }, 300)
    },

    // 接受注册 -> 关闭
    closeRegiter(bel) {
      this.DialogRegiter = bel
    },

    Openligin(bol) {
      this.DialogLogin = bol
    },


    // header 监听头部 变色
    handScroll() {
      let _scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      _scrollTop > 150 ? this.handerbg = true : this.handerbg = false
    },

    // 跳转游戏
    SetGame(item) {
      if (this.$store.state.islogin !== 0) {
        let params = JSON.parse(item.params)
        if(params.ishall == 1){
          this.$router.push({ name: 'Hall', params: { api_name: item.api_name } })
          return;
        }
        const routeData = this.$router.resolve({
          name: 'LoginToSupplier',
          query: {
            api_code: item.api_name,
            ...params,
          },
        })
        window.open(routeData.href, '_blank', 'width=1200,height=900')
      } else {
        this.$message.error({
          message: '请登录后进入游戏',
        })
      }
    },

    // 登录请求
    setLogin(data) {
      getLogin(data)
        .then(res => {
          Message.success('登录成功！')
          this.$store.dispatch('CunisLogin', 1)
          this.$store.dispatch('CunToken', res.data)
          this.setMe()
          if (this.DialogLogin) {
            this.DialogLogin = false
          }
        })
        .catch(err => {
          this.$message.error(err.message)
          this.$refs.formInline.resetFields();
        })
    },

    // 获取用户信息
    setMe() {
      getme()
        .then(res => {
          this.$store.dispatch('CunInfo', res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 获取游戏标题
    async setgemetitle() {
      try {
        let { data: arr } = await getgames()
        this.gametitlelist = arr
        this.ForGame()
      } catch (error) {
        console.log(error);
      }
    },


    ForGame() {
      let len = this.gametitlelist.length
      let du = this.routerlist.length
      for (let i = 0; i < len; i++) {
        let item = this.gametitlelist[i]
        if (item.title !== '热门' && item.child !== null) {
          getgamelist(item.child[0].game_type).then(red => {
            item.gamelist = red.data
            this.$set(this.gametitlelist, i, item)
          }).catch(err => {
            console.log(err);
          })
        }
        for (let y = 0; y < du; y++) {
          const val = this.routerlist[y];
          item.title == val.id ? item.routelink = val.path : ''
        }
      }
    },



    // 打开忘记密码弹窗
    openwangdailog() {
      this.DialogLogin = false
      setTimeout(() => {
        this.DialogWangji = true
      }, 300)
    },

    // 关闭忘记弹窗
    showWangji(bool) {
      this.DialogWangji = bool
    },




    //退出
    async letout() {
      MessageBox.confirm('此操作将退出当前用户, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          logout()
            .then(() => {
              window.localStorage.clear()
              Message({
                type: 'success',
                message: '退出成功!',
              })

              this.$router.push('/')
              window.location.reload()
            })
            .catch(err => {
              Message({
                type: 'info',
                message: err.messages,
              })
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: '已取消退出',
          })
        })
    },


    // 刷新钱包
    RefreshMoney() {
      if (!this.isreshleh) {
        this.setMe()
        this.isreshleh = true
        let that = this
        that.$message.success({
          message: '刷新成功！',
          duration: 2000,
          onClose() {
            that.isreshleh = false
          },
        })
      } else {
        this.$message.error('请勿频繁操作！')
      }
    },

    // 客服请求
    Setservice() {
      let url = window.location.host
      // let url = 'web.aabet8.com'
      getConfig(url, 'service').then(res => {
        window.localStorage.setItem('link', res.data.service_link)
        this.servicelink = res.data.service_link
        //this.QQlink = 'http://wpa.qq.com/msgrd?v=1&uin=' + res.data.kefu_qq + '&site=qq&menu=yes'
        const routeData = this.$router.resolve({
          name: 'ContactUs'
        })
        this.QQlink = routeData.href;
      }).catch(err => {
        console.log(err.message);
      })
    },

    // 打开客服窗口
    Getlink(id) {
      let link = null
      id == 1 ? link = this.servicelink : link = this.QQlink
      window.open(link, '_blank', 'width=1100,height=900')
    },

    gametitle(title,index = 0){
      var arr = String(title).split('-');
      if(arr[index]){
        return arr[index];
      } else{
        return '';
      } 
    }
  },

  mounted() {
    this.setMe()
    this.Setservice()
    this.setgemetitle() // 获取游戏标题
    window.addEventListener('scroll', this.handScroll)
    if(this.$store.state.islogin == 0){
      this.$router.push('/Login')
    }
  },

  watch: {
    '$store.state.key'(nval) {
      if (nval) {
        this.formInline.key = nval
        this.Loginfrom.key = nval
        this.formInline.password !== '' ? this.setLogin(this.formInline) : ''
        this.Loginfrom.password !== '' ? this.setLogin(this.Loginfrom) : ''
      }
    }
  }

}
</script>
<style src="@/styles/headers.less" lang="less" scoped></style>
